
import { Note } from "../note.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class NoteSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const note = new Note();

        this._copyAttributes(note, data);

        return note;

    }

}
